import { URL_API } from "@/config";
import { tokenDecrypted } from "@/utils/decryptToken";
import { url } from "@/utils/urlParam";
import axios from "axios";

export const GetNeedApprovalAPI = async ({
  companyId,
  departementId,
  employeeId,
}) => {
  try {
    const params = new URLSearchParams(url.search);
    if (companyId) {
      params.append("company_id", companyId);
    }

    if (departementId) {
      params.append("departement_id", departementId);
    }

    if (employeeId) {
      params.append("employee_id", employeeId);
    }
    const response = await axios.get(
      `${URL_API}/need-approval?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${tokenDecrypted()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error.response;
  }
};
